
<div class="w-full flex flex-col h-full">
  @if(data.topContent && !filterType) {
    <tier-badge
      class="-mt-3"
      [topContent]="data.topContent"
      [topContentStyles]="data.topContentStyles"
      [topBackgroundColor]="data.topBackgroundColor"
      [topTextColor]="data.topTextColor"
    ></tier-badge>
  }
  <div
    class="flex flex-col justify-start w-full content-card max-w-[364px] w-full p-v-spacing shadow-card rounded-t-ace-mode rounded-b-ace-mode flex-1 ace-mode-pill-card--no-glow {{
      theme?.root
    }} {{ cardBorderClass }}"
    [ngClass]="{'rounded-ace-mode': isAceDesign}"
    >
    @if (cardBorderClass) {
      <product-pill [pills]="data.productEntry?.[0]?.productPills"></product-pill>
    }
    @if (data.showTitle) {
      <div class="mt-0 mb-4 wysiwyg content-card__title" [innerHTML]="data.cardTitle"></div>
    }
    @if (starRating) {
      <div class="stars flex sm:flex-col md:flex-row lg:flex-col xl:flex-row items-left mb-v-spacing">
        <div class="star-container h-[1.5rem] min-w-[75px]">
          @for (i of [].constructor(starRating); track i) {
            <fa-icon
              class="star__solid fa-1x"
              [icon]="fasStar"
              [styles]="faStarStyles"
              >
            </fa-icon>
          }
          @for (i of [].constructor(5 - starRating); track i) {
            <fa-icon
              class="star__regular pr-0.5 fa-1x"
              [icon]="farStar"
              [styles]="faStarStyles"
              >
            </fa-icon>
          }
        </div>
        @if (starCaption) {
          <span class="text-xs pl-3 sm:pl-0 md:pl-3 lg:pl-0 xl:pl-3 flex items-center">{{
            starCaption
          }}</span>
        }
      </div>
    }
    @if (textContent) {
      <div class="wysiwyg mb-v-spacing {{ checkStyle }}" [innerHTML]="textContent"></div>
    }
    @if (showPricing) {
      <div class="w-full product mt-auto mb-v-spacing text-lg decoration-vis-dark  {{ checkStyle }}">
        <div class="font-normal text-sm leading-5 mb-1.5">{{ priceText }}</div>
        <p class="large flex items-center sm:flex-wrap">
          @if (showOriginal) {
            <span class="line-through original-price font-extrabold"
              >${{ product.apiData.originalPrice | customNumber : '1.2-2' }}</span
              >
            }
            <span class="font-extrabold pl-1.5 discount-price"
              >${{ product.apiData.discountPrice | customNumber : '1.2-2' }}</span
              >
              @if (showFee) {
                <span class="text-sm pl-1.5 product-fee">+
                  <span (click)="activateModal()" class="product-fee-link !mt-0 !font-normal !text-sm !inline">
                    {{feeLabel}}
                  </span>
                </span>
              }
              @if (showSavings) {
                <span class="text-sm pl-1.5 content-card__savings">You save ${{ savings }}</span>
              }
            </p>
          </div>
        }
        @if (showCTA) {
          <vision-button
            [class.mt-auto]="!showPricing"
            defaultStyle="primary"
            [data]="buttonData"
          ></vision-button>
        }

        <!-- Button component for Schedule -->
        @if (viewScheduleLabel) {
          <div class="w-full xs:mr-v-spacing lg:mr-0 xl:mr-v-spacing mt-3 text-center">
            <button class="tertiary-button v-button" (click)="showWebinarSchedule($event, data.webinarData)">{{data.webinarData ? viewScheduleLabel : ''}}</button>
          </div>
        }

        @if (isLearnMoreIncluded) {
          <vision-button
            [class]="lmLabel && lmLink ? '' : 'invisible hidden md:block'"
            defaultStyle="tertiary"
            class="mt-3"
            [data]="buttonLinkData"
          ></vision-button>
        }
        @if (showDisclaimer) {
          <div class="wysiwyg mt-6 p-4 bg-chalk w-full {{ checkStyle }}">{{ disclaimer }}</div>
        }
      </div>
    </div>

